module.exports = __webpack_public_path__ + "cardano_coin.svg?6aea691c581b22a12b85bbe81506ae8b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/cardano_coin.svg
// module id = 1106
// module chunks = 2